<template>
  <div class="contact-us">
    <innerBanner :banner="$t('contactUs.banner')" />
    <div class="contact-us-wrap wp2">
      <div class="title">
        <p>{{ $t('contactUs.txt.1') }}</p>
        <p>{{ $t('contactUs.txt.2') }}</p>
      </div>
      <div class="desc">{{ $t('contactUs.txt.3') }}</div>

      <div class="form-wrap">
        <el-form
          ref="form"
          :hide-required-asterisk="true"
          :model="form"
          :rules="rules"
          label-position="top"
        >
          <div class="form-row">
            <el-form-item :label="$t('contactUs.form.1')" prop="name">
              <el-input v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item :label="$t('contactUs.form.2')" prop="email">
              <el-input v-model="form.email"></el-input>
            </el-form-item>
            <el-form-item :label="$t('contactUs.form.9')" prop="phone">
              <el-input v-model="form.phone"></el-input>
            </el-form-item>
          </div>
          <div class="form-row">
            <el-form-item :label="$t('contactUs.form.12')" prop="region">
              <el-select
                v-model="form.region"
                :placeholder="$t('contactUs.form.13')"
              >
                <el-option
                  v-for="(item, index) in states"
                  :key="index"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('contactUs.form.3')" prop="department">
              <el-select
                v-model="form.department"
                :placeholder="$t('contactUs.form.4')"
              >
                <el-option
                  v-for="(item, index) in $t('contactUs.department')"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('contactUs.form.11')" prop="business">
              <el-select
                v-model="form.business"
                :placeholder="$t('contactUs.form.14')"
              >
                <el-option
                  v-for="(item, index) in $t('contactUs.business')"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
          <el-form-item :label="$t('contactUs.form.5')" prop="content">
            <el-input
              v-model="form.content"
              :rows="5"
              resize="none"
              type="textarea"
            ></el-input>
          </el-form-item>
        </el-form>
        <p>{{ $t('contactUs.form.8') }}</p>
        <div v-if="!isDisabled" class="submit small-btn hollow" @click="submit">
          {{ $t('contactUs.form.6') }}
        </div>
        <div v-else class="submit small-btn hollow">
          {{ $t('contactUs.form.7') }}
        </div>
      </div>
      <div class="map-wrap">
        <div class="title">{{ $t('contactUs.txt.4') }}</div>
        <div class="desc">{{ $t('contactUs.txt.5') }}</div>
        <div class="map">
          <positionMap />
        </div>
        <div class="address">
          <addressList />
        </div>
      </div>
    </div>
    <subscribe />
    <div class="succ-pop" v-if="showSucc">
      <div class="pop-mask" @click="showSucc = false"></div>
      <div class="succ-pop-con">
        <h3>{{ $t('contactUs.txt.6') }}</h3>
        <p>{{ $t('contactUs.txt.7') }}</p>
        <router-link class="back" to="/">{{
          $t('contactUs.txt.8')
        }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import innerBanner from '@/components/innerBanner'
import positionMap from '@/components/positionMap'
import addressList from '@/views/aboutUs/modules/addressList'
import subscribe from '@/components/subscribe'

export default {
  name: 'contactus',
  components: {
    innerBanner,
    positionMap,
    addressList,
    subscribe
  },
  data() {
    return {
      isDisabled: false,
      showSucc: false,
      form: {},
      rules: {
        name: [
          {
            required: true,
            message: 'This field is required!',
            trigger: 'blur'
          }
        ],
        email: [
          {
            required: true,
            message: 'This field is required!',
            trigger: 'blur'
          },
          {
            type: 'email',
            message: 'Invalid email address!',
            trigger: ['blur']
          }
        ],
        phone: [
          {
            required: true,
            message: 'This field is required!',
            trigger: 'blur'
          }
        ],
        region: [
          {
            required: true,
            message: 'This field is required!',
            trigger: 'change'
          }
        ],
        business: [
          {
            required: true,
            message: 'This field is required!',
            trigger: 'change'
          }
        ],
        department: [
          {
            required: true,
            message: 'This field is required!',
            trigger: 'change'
          }
        ],
        content: [
          {
            required: true,
            message: 'This field is required!',
            trigger: 'blur'
          }
        ]
      },
      states: [
        'Outside U.S.',
        'Alabama',
        'Alaska',
        'American Samoa',
        'Arizona',
        'Arkansas',
        'California',
        'Colorado',
        'Connecticut',
        'Delaware',
        'District of Columbia',
        'Federated States of Micronesia',
        'Florida',
        'Georgia',
        'Guam',
        'Hawaii',
        'Idaho',
        'Illinois',
        'Indiana',
        'Iowa',
        'Kansas',
        'Kentucky',
        'Louisiana',
        'Maine',
        'Marshall Islands',
        'Maryland',
        'Massachusetts',
        'Michigan',
        'Minnesota',
        'Mississippi',
        'Missouri',
        'Montana',
        'Nebraska',
        'Nevada',
        'New Hampshire',
        'New Jersey',
        'New Mexico',
        'New York',
        'North Carolina',
        'North Dakota',
        'Northern Mariana Islands',
        'Ohio',
        'Oklahoma',
        'Oregon',
        'Palau',
        'Pennsylvania',
        'Puerto Rico',
        'Rhode Island',
        'South Carolina',
        'South Dakota',
        'Tennessee',
        'Texas',
        'Utah',
        'Vermont',
        'Virgin Island',
        'Virginia',
        'Washington',
        'West Virginia',
        'Wisconsin',
        'Wyoming'
      ]
    }
  },
  mounted() {
    window.scrollTo(0, 0)
  },
  methods: {
    submit: function() {
      this.$refs['form'].validate(async (valid) => {
        if (!valid) return
        this.isDisabled = true
        const { data: res } = await this.$http.post(
          `${this.$baseUrl}/contact-email`,
          this.form
        )
        if (res.meta.status !== 200)
          return this.$message.error('发送邮件失败！')
        setTimeout(() => {
          this.showSucc = true
        }, 0)
        this.isDisabled = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.succ-pop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;

  .succ-pop-con {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 480px;
    padding: 44px 0;
    background-color: #fff;
    border-radius: 10px;
    text-align: center;

    h3 {
      @extend .h3-24px;
      margin-bottom: 8px;
      font-weight: normal;
    }

    p {
      @extend .semibold-14px;
      margin-bottom: 38px;
      font-weight: normal;
    }

    a {
      text-decoration: underline;
      font-weight: 600;
      font-size: 16px;
      line-height: 150%;
      font-weight: normal;
    }
  }
}

//contact-us
.contact-us {
  .contact-us-wrap {
    padding: 66px 0;

    .title {
      @extend .h1-36px;
      margin-bottom: 24px;

      p {
        text-align: center;
        font-weight: 550;
      }
    }

    .desc {
      text-align: center;
      font-family: 'PingFang HK';
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      margin-bottom: 32px;
    }

    .el-form {
      .el-form-item {
        margin-bottom: 16px;
      }

      .el-form-item__label {
        line-height: 24px;
        margin-bottom: 8px;
        @extend .semibold-16px;
        padding-bottom: 0;
      }

      .form-row {
        display: flex;
        justify-content: space-between;

        .el-form-item {
          flex: 1 0 30%;

          .el-select {
            width: 100%;
          }
        }

        .el-form-item + .el-form-item {
          margin-left: 40px;
        }
      }

      .el-textarea__inner,
      .el-input__inner {
        border: 1px solid #dddbcb;
        border-radius: 10px;
        font-family: 'PingFang HK';
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
      }

      .el-form-item__error {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        color: #e50012;
        position: static;
      }
    }

    .form-wrap {
      padding-bottom: 80px;
    }

    .form-wrap .submit {
      margin-top: 32px;
      width: 72px;
    }

    .map-wrap {
      .title {
        text-align: center;
        @extend .title1;
        margin-bottom: 24px;
      }

      .desc {
        text-align: center;
        @extend .regular-16px;
        margin-bottom: 25px;
      }

      .map {
        max-width: 780px;
        margin: 0 auto 40px;
      }
    }
  }
}

@media only screen and (max-width: 1199px) {
  .contact-us .contact-us-wrap {
    padding: 66px 20px;
  }

  .contact-us .contact-us-wrap .el-form .form-row .el-form-item {
    flex: 1 0 28%;
  }
}

@media only screen and (max-width: 767px) {
  .contact-us .contact-us-wrap {
    padding: 40px 20px;
  }

  .contact-us .contact-us-wrap .title {
    font-size: 20px;
    margin-bottom: 10px;
  }

  .contact-us .contact-us-wrap .el-form .form-row {
    display: block;
  }

  .contact-us
    .contact-us-wrap
    .el-form
    .form-row
    .el-form-item
    + .el-form-item {
    margin-left: 0;
  }

  .position-map {
    width: 680px;
    -webkit-transform-origin: 0 0;
    -moz-transform-origin: 0 0;
    -ms-transform-origin: 0 0;
    -o-transform-origin: 0 0;
    transform-origin: 0 0;
    -webkit-transform: scale(0.5);
    -moz-transform: scale(0.5);
    -ms-transform: scale(0.5);
    -o-transform: scale(0.5);
    transform: scale(0.5);
  }

  .contact-us .contact-us-wrap .map-wrap .map {
    margin-bottom: -100px;
  }
}
</style>
